import logo from "./logo.svg";
import "./App.css";
import { useState, Fragment } from "react";
// import { BrowserRouter as Router, Route, Switch, withRouter, Redirect } from 'react-router-dom';
import {
  Routes,
  Route,
  BrowserRouter,
  Switch,
  Navigate,
} from "react-router-dom";
import React from "react";
import Sidebar from "./components/Sidebar1";
import GrowthSummary from "./components/GrowthSummary";
import RBMlevelBudget from "./components/RBMlevelBudget";
import SkuSummary from "./components/SkuSummary";
import BUHBudgetSummary from "./components/BUHBudgetSummary";
import BUbdget from "./components/BUbudget";
import Topbar from "./components/Topbar";
import AdminTables from "./components/Admin/AdminTables";
import ABMSelection from "./components/Admin/ABMSelection";
import REPHQSelection from "./components/Admin/REPHQSelection";
import Login from "./components/Login";
import RequireAuth from "./components/RequireAuth";
import Missing from "./components/Missing";
import LoginFun from "./components/LoginFun";
// import Layout from "./components/Layout"
import Layout from "./components/Layout";
import NoRole from "./components/NoRole";
import CommercialHeadTable from "./components/Tables/CommercialHeadTable";
import REPHQLevelBudget from "./components/REPHQLevelBudget";
import REPHQBudget from "./components/REPHQBudget";
import ABMlevelBudget from "./components/ABMLevelBudget";
import LoginV2 from "./components/Loginv2";
import CommercialHeadBUH from "./components/Tables/CommercialHeadBUH";
import RBMGrowthSummary from "./components/RBMGrowthSummary";
import RBMSkuSummary from "./components/RBMSkuSummary";
import RBMBuBudgetSummary from "./components/RBMBuBudgetSummary";
import RBMBrandSummary from "./components/RBMBrandSummary";
import ABMSkuSummary from "./components/ABMSkuSummary";
import REPHQSkuSummary from "./components/REPHQSkuSummary";
import RBMSummary from "./components/RBMSummary"
import AlternateABM from "./components/AlternateABM"
import RepHqSummary from "./components/RepHqSummary";
import RepBrandSummary from "./components/RepBrandSummary";
import RBMSkuLevel from "./components/RBMSkuLevel";
import BrandSummary from "./components/BrandSummary";
import HistoricalBuhData from "./components/HistoricalBUHData";
import HistoricalRBMData from "./components/RBMHistoricalData";
import ADjustedCheckREPHQ from "./components/AdjustedCheckREPHQ";
import ADjustedCheckABM from "./components/AdjustedCheckABM";
import REPHQGrowthSummary from "./components/REPHQGrowthSummary";
// import BUHBudgetSummary from "./components/BUHBudgetSummary";

function App() {
  const Authenticated = false;
  // localStorage.setItem("Auth", true);
  // localStorage.setItem("ROLE", "ADMIN");
  // localStorage.setItem("username", "Ezhilarasi_S");
  // localStorage.setItem("email", "ezhilarasi.8.s@gsk.com");
  // localStorage.setItem("teamcode", "T1");
  // localStorage.setItem("rbmcode", "1G");
  // localStorage.setItem('quarter',"Q3")
  // localStorage.setItem('year',"2024")
  // const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  return (
    <div
      style={{
        backgroundColor: "#ffff",
        display: "flex",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      {/* <Topbar /> */}
      <Sidebar Authenticated={Authenticated} />
      <Fragment>
        <Routes>
          <Route path="*" element={<Navigate to="/login" />}></Route>
          <Route
            path="/login"
            element={<LoginFun Authenticated={Authenticated} />}
          ></Route>
          <Route path="/loginv2" element={<LoginV2 />}></Route>

          {/* <Route path="/" element={<Layout />}></Route> */}
          {/* <Route path="/" element={<Layout />}></Route> */}
          <Route element={<RequireAuth allowedRoles={["BUH"]} />}>
            {/* <Route path="/" element={<Sidebar />} />   */}
            {/* <Route path="/" element={<Layout />}></Route>   */}
            <Route path="rbmlevelbudget" element={<RBMlevelBudget />}></Route>
            <Route path="growthsummary" element={<GrowthSummary />}></Route>
            <Route path="skusummary" element={<SkuSummary />}></Route>
            <Route path="rbmsummary" element={<RBMSummary />}></Route>
            <Route path="bubudget" element={<BUHBudgetSummary />}></Route>
            <Route path="historicalbudgetdata" element={<HistoricalBuhData />}></Route>
            <Route path="brandsummary" element={<BrandSummary />}></Route>
            <Route path="commercialheadbuh" element={<CommercialHeadBUH />}></Route>
            {/* <Route path="rephqlevelbudget" element={<REPHQLevelBudget />}></Route>
            <Route path="abmlevelbudget" element={<ABMlevelBudget />}></Route> */}
          </Route>

          <Route element={<RequireAuth allowedRoles={["ADMIN"]} />}>
            <Route path="admin/:table" element={<AdminTables />}></Route>
          </Route>
          <Route element={<RequireAuth allowedRoles={["RBM"]} />}>
           <Route path="abmlevelbudget" element={<ABMlevelBudget />}></Route>
           {/* <Route path="alternateabmlevelbudget" element={<AlternateABM />}></Route> */}
            <Route path="abmgrowthsummary" element={<RBMGrowthSummary />}></Route>
            <Route path="rephqgrowthsummary" element={<REPHQGrowthSummary />}></Route>
            {/* <Route path="rbmskusummary" element={<RBMSkuLevel />}></Route> */}
            <Route path="rbmbubudget" element={<RBMBuBudgetSummary />}></Route>
            <Route path="adjustedcheckabm" element={<ADjustedCheckABM />}></Route>
            <Route path="adjustedcheckrephq" element={<ADjustedCheckREPHQ />}></Route>
            <Route path="rbmbrand" element={<RBMBrandSummary />}></Route>
            <Route path="rbmhistoricaldata" element={<HistoricalRBMData />}></Route>
            
            <Route path="abmselection" element={<ABMSelection />}></Route>
          </Route>

          <Route element={<RequireAuth allowedRoles={["ABM"]} />}>
            <Route path="rephqselection" element={<REPHQSelection />}></Route>
            <Route path="abmskusummary" element={<ABMSkuSummary />}></Route>
            <Route path="replevelsummary" element={<RepHqSummary />}></Route>
            <Route
              path="abmandrephqlevelbudget"
              element={<REPHQLevelBudget />}
            ></Route>
          </Route>
          <Route element={<RequireAuth allowedRoles={["REPHQ"]} />}>
          <Route path="rephqbrandsummary" element={<RepBrandSummary />}></Route>
            <Route
              path="rephqlevelbudget"
              element={<REPHQBudget />}
            ></Route>
            {/* <Route path="rephqskusummary" element={<REPHQSkuSummary />}></Route> */}
          </Route>
          <Route element={<RequireAuth allowedRoles={["NOROLE"]} />}>
            <Route path="role" element={<NoRole />}></Route>
          </Route>
          <Route element={<RequireAuth allowedRoles={["COMMERCIALHEAD"]} />}>
            <Route
              path="commercialheadtable"
              element={<CommercialHeadTable />}
            ></Route>
          </Route>
          
          {/* <Route path="*" element={<Missing />} /> */}
        </Routes>
      </Fragment>
    </div>
  );
}

export default App;
